import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "rec-tag__wrapper" };
const _hoisted_2 = ["aria-label"];
import { toRem } from "@/common/helpers/style";
import { computed, useTemplateRef } from "vue";
import { checkTruncation } from "@/common/helpers/truncation";
// Components
import SvgIcon from "@/common/components/SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecTag',
    props: {
        tag: { default: "a" },
        text: { default: "" },
        color: { default: "primary" },
        closable: { type: Boolean },
        trim: { default: "1" },
        borderRadius: { default: 3 }
    },
    emits: ["close"],
    setup(__props) {
        _useCssVars(_ctx => ({
            "v1896a6d0": (borderRadiusCss.value),
            "v65471eae": (_ctx.color),
            "v8f9259e8": (trimCss.value)
        }));
        const props = __props;
        // Computed styles
        const trimCss = computed(() => `${props.trim || "1"}`);
        const borderRadiusCss = computed(() => {
            if (typeof props.borderRadius === "string") {
                return props.borderRadius.split(" ").map(toRem).join(" ");
            }
            if (Array.isArray(props.borderRadius)) {
                return props.borderRadius.map(toRem).join(" ");
            }
            return toRem(props.borderRadius);
        });
        // Text Truncation
        const textEl = useTemplateRef("textEl");
        const isTruncated = computed(() => !!textEl.value && checkTruncation(textEl));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), _mergeProps({
                class: [`rec-tag bg-${__props.color} text-on-${__props.color}`, { 'rec-tag--closable': __props.closable }]
            }, _ctx.$attrs), {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            ref_key: "textEl",
                            ref: textEl,
                            class: "rec-tag__trim"
                        }, [
                            _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ isTruncated: isTruncated.value })), () => [
                                _createTextVNode(_toDisplayString(__props.text), 1)
                            ])
                        ], 512),
                        (__props.closable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "rec-tag__close-button",
                                "aria-label": _ctx.$t('Remove') + ' ' + __props.text,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('close')), ["stop", "prevent"]))
                            }, [
                                _createVNode(SvgIcon, {
                                    icon: "icon-close-3",
                                    class: "rec-tag__close-button__icon"
                                })
                            ], 8, _hoisted_2))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 3
            }, 16, ["class"]));
        };
    }
});
